export default __webpack_public_path__ + "static/media/cz-p-09.bbf77144.svg";